import React, {useContext} from 'react'

export const useI18nContext = () => useContext(I18nContext)
const I18nContext = React.createContext({"lang": "de", "ready": false})
export default I18nContext